import { Util } from '@odm-operations-tooling/cockpit-commons';
import { FilterEntry } from './FilterEntry';
import { COLUMN_DEFAULT_VALUES, COLUMN_TYPE, isColumnFilterable } from './columnTypes';

function toEnumModelEntries(items) {
    return items.map(entry => ({
        item: entry,
        selected: false
    }));
}

function getEnumFilterModelEntries(key, rawData) {
    const entries = Util.array.unique(rawData.map(row => row[key]).flat());
    if (typeof entries[0] === 'string') {
        Util.array.sortLocale(entries);
    } else if (typeof entries[0] === 'number') {
        entries.sort((a, b) => {
            if (a < b) {
                return -1;
            } else if (a > b) {
                return 1;
            } else {
                return 0;
            }
        });
    }

    return toEnumModelEntries(entries);
}

export function getRangeSliderModelValues(model) {
    if (model.min === model.max) {
        // Range slider does not support equal min and max values
        model.max += 1;
    }
    if (model.definedMin === Infinity) {
        model.definedMin = 0;
    }
    model.from = model.min;
    model.to = model.max;
    return model;
}

function getFilterModelForRangeColumn(key, rows) {
    const model = {
        min: Infinity,
        definedMin: Infinity, // min value that is not zero (because zero means undefined here)
        max: -Infinity
    };

    for (const row of rows) {
        model.min = Math.min(model.min, row[key]);
        model.definedMin = row[key] === 0 ? model.definedMin : Math.min(model.definedMin, row[key]);
        model.max = Math.max(model.max, row[key]);
    }

    return getRangeSliderModelValues(model);
}

export function getFilterModel(filterKey, filterType, tableRows) {
    switch (filterType) {
        case COLUMN_TYPE.enum:
        case COLUMN_TYPE.searchableEnum:
            return getEnumFilterModelEntries(filterKey, tableRows);

        case COLUMN_TYPE.dateTime:
        case COLUMN_TYPE.duration:
        case COLUMN_TYPE.number:
            return getFilterModelForRangeColumn(filterKey, tableRows);
        default:
            return '';
    }
}

export function fillMissingKeys(columns, rows) {
    for (const row of rows) {
        for (const [key, config] of Object.entries(columns)) {
            if (!row.hasOwnProperty(key)) {
                row[key] = COLUMN_DEFAULT_VALUES[config.type];
            }
        }
    }
}

export function getAllTableHeaders(columns) {
    return Object.entries(columns).map(([key, config]) => ({
        id: key,
        title: config.title ? config.title : config.label
    }));
}

function toTitleByKeyMap(columns) {
    return columns.reduce((agg, [key, config]) => {
        agg[key] = config.title;
        return agg;
    }, {});
}
export function getInitialTableHeaders(columns) {
    const initialTableHeaders = Object.entries(columns).filter(([, config]) => config.initial);
    return toTitleByKeyMap(initialTableHeaders);
}

export function buildFiltersForTableData(columns, tableRows) {
    const filters = {};

    for (const key of Object.keys(columns)) {
        const filterType = columns[key].type;

        if (!isColumnFilterable(filterType)) {
            continue;
        }

        const filterEntry = new FilterEntry(filterType);
        filterEntry.model = getFilterModel(key, filterType, tableRows);
        filters[key] = filterEntry;
    }
    return filters;
}

export {
    // Just for testing!
    FilterEntry as __FilterEntry
};
